export default __webpack_public_path__ + "static/media/non-crypto-traders.52e95877.png";